import React, { forwardRef } from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { ControllableOptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { useFormContext } from 'react-hook-form';

import st from '../popovers.module.sass';

function ShoesFilterPopover(
  {
    name = 'shoes_apparent_colors',
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { control } = useFormContext();

  return (
    <FilterPopover
      {...props}
      name={name}
      ref={ref}
    >
      <ControllableOptionsFilter
        control={control}
        isSearchable={false}
        name={name}
        options={EVENT_ENUMS.LOWER_BODY.SHOES.APPARENT_COLOR.raw}
      />
      <div className={st.Divider} />
    </FilterPopover>
  );
}

const ShoesFilterPopoverWithRef = forwardRef(ShoesFilterPopover);
export { ShoesFilterPopoverWithRef as ShoesFilterPopover };
